
import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import $ from 'jquery';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import NavViewMobile from './component/NavViewMobile';
import HomePosterView from '../component/home/HomePosterView';
import SectionView from '../component/home/SectionView';
import GamePosterView from '../component/home/GamePosterView';
import AboutSectionView from '../component/home/AboutSectionView';
import { getImgPath } from '../store/JSTool';
import PageFooter from '../page/PageFooter';
import HomeNewsMobile from './component/HomeNewsMobile';

export default function HomePageMobile() {

    let navId = 'home_page_nav';
    let pageId = 'home_page_div';
    let sectionIdAry = ['home_works', 'home_news', 'home_about'];

    React.useEffect(() => {
        JSTool.addPageScrollListener(pageId, navId, 0, sectionIdAry);
    }, []);

    return (
        <Stack
            component={'div'}
            sx={{
                width: 1,
                height: window.innerHeight,
                position: 'relative',
            }}>
            <NavViewMobile navId={navId} pageId={pageId} />

            <Stack
                id={pageId}
                component={'div'}
                sx={{
                    width: 1,
                    overflow: 'auto',
                    position: 'relative',
                    alignItems: 'center',
                }} >
                <HomePosterView />
                <SectionView id={sectionIdAry[0]} title='Our Games' isBlack={true} />
                <GamePosterView />

                <SectionView id={sectionIdAry[1]} title='News' />
                <HomeNewsMobile />

                <SectionView id={sectionIdAry[2]} title='About' />
                <AboutSectionView />

                <Box
                    id='apj_logo_id'
                    component={'img'}
                    src={getImgPath('logo_black.png')}
                    sx={{
                        opacity: 0,
                        my: 3,
                        width: 0.4,
                    }} />

                <PageFooter pageId={pageId} />

            </Stack>
        </Stack>
    );
}